import React from 'react'
import './Author.scss';
import { NavLink } from 'react-router-dom';

export const Author = () => {
  return (
    <p className='author' >Realizado por <NavLink target='_blank' to='https://lucasigna.vercel.app/' className='link'>Lucas González</NavLink></p>
  )
}
